import { memo } from 'react'
import { cloneDeep, isEqual } from 'lodash-es'

//reduces re-renders caused by changed location.key - https://github.com/remix-run/react-router/discussions/8025
export default function routeMemo(route) {
	return memo(route, (prev, current) => {
		const cleanedPrev = cloneDeep(prev)
		const cleanedCurrent = cloneDeep(current)
		delete cleanedPrev.location.key
		delete cleanedCurrent.location.key
		return isEqual(cleanedPrev, cleanedCurrent)
	})
}
